import { render, staticRenderFns } from "./votePage.vue?vue&type=template&id=41366617&scoped=true&"
import script from "./votePage.vue?vue&type=script&lang=js&"
export * from "./votePage.vue?vue&type=script&lang=js&"
import style0 from "./votePage.vue?vue&type=style&index=0&id=41366617&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41366617",
  null
  
)

export default component.exports